<template>
  <section> 
        
  </section>  
</template>

<script>
import indexMix  from './indexMix.js'
import SwInputs from '@/components/forms/inputs.vue'


export default { 
  name: "datos_pacientes",
  mixins: [indexMix],
  components: {
  SwInputs,     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
.close:focus{
  outline: none !important;
}
</style>

